import { useCallback } from 'react';

type PaginatedOptionsListProps = {
  enabled?: boolean;
  onBottomReached?: () => void;
  height?: number | string;
  children: React.ReactNode;
  stopAll?: (e: React.MouseEvent) => void;
  className?: string;
};

export const PaginatedOptionsList: React.FC<PaginatedOptionsListProps> = ({
  enabled = true,
  onBottomReached,
  height = 260,
  children,
  stopAll,
  className,
}) => {
  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      if (!enabled) return;

      const el = e.currentTarget;
      const threshold = 40;
      const atBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

      if (atBottom) onBottomReached?.();
    },
    [enabled, onBottomReached]
  );

  return (
    <div
      onScroll={handleScroll}
      className={className}
      onMouseDown={(e) => stopAll?.(e)}
      onClick={(e) => stopAll?.(e)}
      style={{
        height,
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      {children}
    </div>
  );
};
